import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { RequisitoRespaldo } from '../_models/requisito-respaldo';
import {RequisitoRespaldoTipoVinculacion} from '../_models/requisito-respaldo-tipo-vinculacion';
import {RequisitoRespaldoProducto} from '../_models/requisito-respaldo-producto';
import {RequisitoRespaldoActividad} from '../_models/requisito-respaldo-actividad';

@Injectable({
  providedIn: 'root'
})
export class RequisitosRespaldosActividadesService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasRespaldosActividades';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as RequisitoRespaldoActividad[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as RequisitoRespaldoActividad[] ) );
  }

  listadoHabilitadosPorUnidadCredito( idSolUc: string ) {
    return this.httClient.get( this.rutServicio + '/solicitudUnidadCredito/' + idSolUc ).pipe( map( res => res as RequisitoRespaldoActividad[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as RequisitoRespaldoActividad ) );
  }

  obtenerPorIdRequisito( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantiaRespaldo/' + id ).pipe( map( res => res as RequisitoRespaldoActividad[] ) );
  }

  listadoPorIdRequisitoHabilitado( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantiaRespaldo/' + id + '/enabled' ).pipe( map( res => res as RequisitoRespaldoActividad[] ) );
  }

  crear( regCrear: RequisitoRespaldoActividad ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as RequisitoRespaldoActividad ) );
  }

  bulk( regCrear: RequisitoRespaldoActividad[] ) {
    const auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.map( x => {
      x.auditoriaUsuario = auditoriaUsuario;
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regCrear ).pipe( map( res => res as
      RequisitoRespaldoActividad ) );
  }

  actualizar( regActualizar: RequisitoRespaldoActividad ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
